import React from 'react'

import personajeTerms from '../../../assets/images/personajeTerms.svg'
import useMediaQuery from '../../../utils/useMediaQuery'

import './modalTerms.scss'
import { termsTest } from './termsData'

const ModalTerms = props => {
  const isMobile = useMediaQuery()

  const { close } = props

  return (
    <div className="f-modalTerms-container">
      <div className="f-modalTerms-container__wrapper">
        <div className="f-modalTerms-container__content">
          <span
            className="f-modalTerms-container__content__close"
            onClick={() => close()}
          />
          <figure>
            <h2>Términos y condiciones</h2>
            {!isMobile && (
              <img
                src={personajeTerms}
                alt="personaje de la secccion terminos y condiciones"
              />
            )}
          </figure>
          <div className="f-modalTerms-container__content__contentTerms">
            <ul>
              {termsTest.map((item, index) => {
                return (
                  <li key={'terms' + index}>
                    <span>{index + 1}.</span> {item}
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalTerms
